import { LoaderFunction, LoaderFunctionArgs, redirect } from "react-router-dom";
import { REACT_APP_BACKENDURL } from "../../../config";
import { defaultSettings } from "../../../contexts/appsettings/defaultSettings";
import { getHierarchyBaseUrl } from "../../../contexts/hierarchy/getHierarchyBaseUrl";
import { loadHierarchy } from "./loadHierarchy";

/**
 * Redirect legacy hierarchy URLs to the canonical hierarchy route.
 *
 * @param props - Loader args from react-router
 * @param props.params - Route params identifying the hierarchy
 * @param props.request - The navigation request object
 * @returns A redirect response to the hierarchy base URL
 */
export const hierarchyRedirectLoader: LoaderFunction = async ({
  params,
  request,
}: LoaderFunctionArgs) => {
  const backEndUrl = REACT_APP_BACKENDURL.includes("_REACT_APP_BACKENDURL_")
    ? defaultSettings.backEndUrl
    : REACT_APP_BACKENDURL;

  const hierarchyId = params.hierarchyId;
  const url = new URL(request.url);
  const searchParams = new URLSearchParams(url.search);

  /* istanbul ignore else */
  if (hierarchyId !== undefined) {
    const hierarchyRequest = await loadHierarchy(backEndUrl, { hierarchyId });
    /* istanbul ignore else */
    if (hierarchyRequest.success && hierarchyRequest.data) {
      const redirectTo = new URL(
        url.origin +
          getHierarchyBaseUrl(hierarchyRequest.data) +
          (params.more !== undefined ? `/${params.more}` : ""),
      );
      /* istanbul ignore else */
      if (searchParams !== undefined) redirectTo.search = searchParams.toString();
      return redirect(redirectTo.toString());
    }
  }

  return redirect("/Corporate");
};
